import { render, staticRenderFns } from "./CountryStats.vue?vue&type=template&id=674a7580&scoped=true"
import script from "./CountryStats.vue?vue&type=script&lang=js"
export * from "./CountryStats.vue?vue&type=script&lang=js"
import style0 from "./CountryStats.vue?vue&type=style&index=0&id=674a7580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a7580",
  null
  
)

export default component.exports